import { urlWithParams } from '@marketplace-web/browser/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const MEMBER_SEARCH_URL = (page: number, searchText: string): string =>
  `/member/general/search?page=${page}&search_text=${searchText}`
